import React from 'react';
import { ReactComponent as CheckIcon } from '../img/check.svg';
import styled from '@emotion/styled';

const StyledCheckLine = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const StyledCheckWrapper = styled.div`
  height: 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export function CheckLine({ children }: { children: React.ReactNode; }) {
  return (
    <StyledCheckLine>
      <StyledCheckWrapper>
        <CheckIcon  />
      </StyledCheckWrapper>
      {children}
    </StyledCheckLine>
  );
}
